// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"596":"22af7e44","787":"958a7485"}[chunkId] + ".chunk.js";
};